const FACILITIES_ACTION_TYPES = {
  SET_ALL_FACILITIES: 'SET_ALL_FACILITIES',
  SET_ALL_FACILITIES_REQUEST: 'SET_ALL_FACILITIES_REQUEST',
  CLEAR_REQUESTS: 'CLEAR_REQUESTS',
  SET_TERMS: 'SET_TERMS',
}

export default FACILITIES_ACTION_TYPES
